module.exports = __webpack_public_path__ + "static/media/seal work4.2a04e858.png";